/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ v: NonNullable<unknown> }} Confirm_Delete_ValveInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete the valve “{v}“ ?" |
*
* @param {Confirm_Delete_ValveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const confirm_delete_valve = /** @type {((inputs: Confirm_Delete_ValveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Delete_ValveInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Are you sure you want to delete the valve “${i?.v}“ ?`)
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer cette tête th. “${i?.v}“ ?`)
});